import api from './api';

const shippingService = {
  getRates: (items, destinationCountry = 'US', subtotal = 0) =>
    api.post('/shipping/rates', { items, destinationCountry, subtotal }),
  getCarriers: () => api.get('/shipping/carriers'),
  getTrackingUrl: (carrier, trackingNumber) =>
    api.get(`/shipping/track/${carrier}/${trackingNumber}`),
};

export default shippingService;
